import { useState } from 'react';
import './Login.css';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setPageNum } from '../Variable/pagenum';
import { checkLoginThunk } from '../Variable/login';
import { AuthGlyph } from '../Main/LoginIcon/LoginIcon';
import type { AppDispatch } from '../customTypes';


export default function Login() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [localError, setLocalError] = useState('');
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		setLocalError('');

		const resultAction = await dispatch(
			checkLoginThunk({ email, password })
		);

		if (checkLoginThunk.fulfilled.match(resultAction)) {
			alert('登录成功');
			dispatch(setPageNum(0));
			navigate('/');
		} else {
			setLocalError((resultAction.payload as string) ?? '登录失败');
		}
	}



	return (
		<div className="auth-page">
			<div className="auth-card">
				<div className="auth-brand">
					<div className="auth-glyph-circle" aria-hidden>
						<AuthGlyph loggedIn={false} />
					</div>
					<h1 className="brand-title">欢迎回来</h1>
					<p className="brand-sub">使用你的账户登录以继续</p>
				</div>

				<form className="auth-form" onSubmit={handleSubmit} noValidate>
					<label className="field">
						<span className="field-label">邮箱/用户名</span>
						<input
							type="text"
							value={email}
							onChange={e=>setEmail(e.target.value)}
							placeholder="yours@example.com/username"
							className="field-input"
							required
						/>
					</label>

					<label className="field">
						<span className="field-label">密码</span>
						<input
							type="password"
							value={password}
							onChange={e=>setPassword(e.target.value)}
							placeholder="password"
							className="field-input"
							required
						/>
					</label>

					{localError && <div className="auth-error">{localError}</div>}

					<button className="btn primary" type="submit">
						登录
					</button>

					<div className="auth-row">
						<button type="button" className="btn ghost"
						onClick={() => navigate('/register')}
						>账号注册</button>
						<a className="auth-link" href="#forgot">忘记密码?</a>
					</div>
				</form>
			</div>
		</div>
	);
}
